import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { StickerCategory, Sticker } from '../../types'
import { getEmojinameByEmojiIndex } from '../../utils/findEmoji'
import { getLanguage } from '../../data/languageCascaderData'

import { supportLanguageList } from '../../data/supportLanguage'

import styles from '../../styles/StickerTagInfo.module.css'
import '../../styles/tagSelect.css'
import StickerTagInfo from './StickerTagInfo'

export default function StickerTagInfoList({
  sticker,
  style,
}: {
  sticker: Sticker
  style?: any
}) {
  const intl = useIntl()
  return (
    <div style={style} className={styles.wrapper}>
      <img src={sticker.origin} alt="sticker" />
      <StickerTagInfo
        textLang={sticker.textLang}
        emojiCategories={sticker.emojiCategories}
      />
    </div>
  )
}
